/* tslint:disable */
import React, { FC, useEffect, useState } from "react";
import { Spin, Table } from "antd";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import CommonService from "../../services/common.service";
import { CorrelationBases } from "../../services/enums";
import { IResultResponse } from "../../models/response/result.model";

interface IProps {
  correlationSettings: {
    correlationBasis: CorrelationBases,
    startDate: any,
    endDate: any,
    instrumentIds?: any[],
    updateTrigger?: number
  }
}

const CryptoCorrelationsTable: FC<IProps> = (props) => {
  const [columns, setColumns] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);

  const query: { [key: string]: any } = {
    ...props.correlationSettings,
    'instrumentIds[]': props.correlationSettings.instrumentIds
  };

  const { loading } = useHttpGet<IResultResponse<any[]>>
    (`${APIRoutes.CORRELATION}`, {
      defaultValue: {
        result: [],
      },
      query: query,
      dependencies: [props.correlationSettings.updateTrigger],
      reject: CommonService.showAllErrors,
      resolve: (response) => {
        const columns1 = [{
          title: "Name",
          dataIndex: "name",
          render: (text: string, record: any) => { return { children: <>{record?.name} ({record.ticker})</> } }
        }];

        const tableData: React.SetStateAction<any[]> = [];
        response.result?.assetCorrelationList
          .sort((a: any, b: any) => a.sortNumber - b.sortNumber)
          .forEach((assetCorrelation: any) => {
            columns1.push({
              title: `${assetCorrelation?.ticker}`,
              dataIndex: `${assetCorrelation?.ticker}`,
              render: (text: string) => {
                const num = parseFloat(text);
                let color = "#fff";
                debugger;

                if (num && num > 0)
                  color = `rgba(0, 255, 33, ${text})`;
                else if (num && num < 0)
                  color = `rgba(255, 0, 33, ${-1 * num})`;

                return {
                  props: {
                    style: { backgroundColor: color }
                  },
                  children: <>{text}</>
                };
              }
            });

            const tableItem: { [key: string]: any } = {
              name: assetCorrelation.name,
              ticker: assetCorrelation.ticker,
            };

            assetCorrelation.correlationArrayList
              .forEach((el: any) => {
                tableItem[`${el.ticker2}`] = CommonService.toLocalNum(el.value);
              });

            tableData.push(tableItem);
          });

        setColumns(columns1);
        setData(tableData);
      }
    });

  return (
    <Spin spinning={loading}>
      <p>Calculated for period from {props.correlationSettings.startDate} to {props.correlationSettings.endDate}</p>
      <Table
        size="small"
        columns={columns}
        dataSource={data || []}
        pagination={false}
        rowKey="name"
      />
    </Spin>
  );
};

export default CryptoCorrelationsTable;
